// src/containers/ListingPageLoader/ListingPageLoader.duck.js

import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { storableError } from '../../util/errors';
import { loadData as loadListingPageData } from '../ListingPage/ListingPage.duck';

// ================ Action types ================ //

export const LOOKUP_REQUEST = 'app/ListingPageLoader/LOOKUP_REQUEST';
export const LOOKUP_SUCCESS = 'app/ListingPageLoader/LOOKUP_SUCCESS';
export const LOOKUP_ERROR = 'app/ListingPageLoader/LOOKUP_ERROR';

// ================ Reducer ================ //

const initialState = {
  listingId: null,
  listingTitle: null,
  lookupInProgress: false,
  lookupError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case LOOKUP_REQUEST:
      return { ...state, lookupInProgress: true, lookupError: null, listingId: null, listingTitle: null };
    case LOOKUP_SUCCESS:
      return { 
        ...state, 
        lookupInProgress: false, 
        listingId: payload.listingId,
        listingTitle: payload.listingTitle,
      };
    case LOOKUP_ERROR:
      return { ...state, lookupInProgress: false, lookupError: payload };
    default:
      return state;
  }
}

// ================ Thunks ================ //

export const lookupListingBySlug = (slug, config) => (dispatch, getState, sdk) => {
  dispatch({ type: LOOKUP_REQUEST });

  return sdk.listings
    .query({
      pub_customSlug: slug,
    })
    .then(response => {
      const listings = response.data.data;

      if (listings.length === 0) {
        const error = new Error('Listing not found');
        error.status = 404;
        dispatch({ type: LOOKUP_ERROR, payload: storableError(error) });
        return null;
      }

      const listing = listings[0];
      const listingId = listing.id;
      const listingTitle = listing.attributes.title;

      dispatch({ 
        type: LOOKUP_SUCCESS, 
        payload: { listingId, listingTitle } 
      });

      // Now load the full listing data using ListingPage's loadData
      // This fetches reviews, time slots, images, etc.
      return dispatch(loadListingPageData({ id: listingId.uuid }, null, config));
    })
    .catch(e => {
      dispatch({ type: LOOKUP_ERROR, payload: storableError(e) });
      throw e;
    });
};

// ================ loadData for SSR ================ //

export const loadData = (params, search, config) => dispatch => {
  const { slug } = params;
  return dispatch(lookupListingBySlug(slug, config));
};